import { useQuery } from "@tanstack/react-query";
import { apiClient } from "../../../../lib/api-client";
import { SalesChannel } from "../types/SalesChannel";

export const useGetSalesChannels = (companyID: number) => {
	const { data, isLoading } = useQuery({
		queryKey: ['sales-channels', companyID],
		queryFn: async () => await apiClient.get('company/sales-channels', {
			params: {
				companyID
			}
		}) as SalesChannel[]
	});

	return {
		data: data || [],
		isLoading: isLoading
	};
};
